import type { Faq as FaqType } from 'libs/http/api/content/content.types';

type Translate = (key: string) => string;

export const getFaqItems = (t: Translate): FaqType[] => [
  {
    id: 'how-current-is-the-company-data',
    default_opened: true,
    question: t('How current is the company data?'),
    answer: t(
      'Records are daily-synced against the source register. Filing cadence differs by jurisdiction, so each field shows the date it was retrieved and, for accounts, the period they cover. We do not describe registry data as real-time, because registers do not publish in real time.',
    ),
  },
  {
    id: 'search-on-national-industry-code',
    question: t('Can I search on a national industry code rather than NAICS?'),
    answer: t(
      'Yes, and it is usually the reason teams move to us. Filter on WZ, ATECO, APE, SBI, CNAE, SIC or the local scheme directly, or use NACE and NAICS when you need a cross-border rollup. Both come back in the export.',
    ),
  },
  {
    id: 'run-outreach-or-export',
    question: t('Can we run outreach from Global Database, or do we export to another tool?'),
    answer: t(
      'Both. You can enrol a segment into a multi-step sequence here, mixing emails with call and research tasks, and track delivery, opens, replies and bounces against the same record. Or export to the sequencer you already use. The advantage of sending from here is suppression: when a company is struck off or dissolved mid-cadence, its contacts are paused automatically rather than emailed for another three weeks.',
    ),
  },
  {
    id: 'where-does-intent-data-fit',
    question: t('Where does intent data fit?'),
    answer: t(
      'It does not, and that is deliberate. We publish filed events with a date and a source registry rather than inferred behavioural scores. Teams that want intent signals usually layer a specialist vendor on top and use our registry identifier as the join key, which is cleaner than trusting one vendor for both.',
    ),
  },
  {
    id: 'what-happens-after-export',
    question: t('What happens to a list after I export it?'),
    answer: t(
      'Subscribe the segment and changes keep arriving: status changes, name changes, new filings, new subsidiaries. Through the CRM connectors those updates land on the records themselves rather than in a separate report nobody opens.',
    ),
  },
  {
    id: 'redistribute-data-in-our-product',
    question: t('Can we redistribute the data inside our own product?'),
    answer: t(
      'In most cases yes. Bulk export and redistribution rights are part of the standard commercial terms, and AI training use can be licensed. Because we source from primary registries rather than resell another vendor’s file, we are not constrained by an upstream provider’s restrictions.',
    ),
  },
  {
    id: 'handle-duplicates-against-crm',
    question: t('How do you handle duplicates against our existing CRM?'),
    answer: t(
      'Matching runs on registry identifier first, then on entity-resolved name and address. Accounts you already own are suppressed from new lists, and existing records are enriched in place rather than duplicated.',
    ),
  },
];
